<template>
	<v-layout row wrap>

		<v-flex xs12 >

			<v-layout row wrap class="mb-4">
				<v-flex md2 xs12 class="align-self-center">
					<h1 class="title mb-2">User Profile</h1>
				</v-flex>
				<v-flex md10 xs12>
					<v-btn color="primary" class="mr-3" style="float:right;" @click="clickUpdatePW">
						<v-icon left>fa-lg fa-key</v-icon>UPDATE USER PASSWORD
					</v-btn>
					<v-btn color="primary" style="float:right;" @click="clickUpdateContactNumber">
						<v-icon left>fa-lg fa-mobile-alt</v-icon>UPDATE CONTACT NUMBER
					</v-btn>
					<v-btn color="primary"  style="float:right;" @click="clickUpdateEmail">
						<v-icon left>fa-lg fa-envelope</v-icon>UPDATE USER EMAIL
					</v-btn>
				</v-flex>
			</v-layout>
			
			
			<v-layout row wrap>
				<v-flex xs12>

					<v-card class="mb-3 mr-3">
						<v-toolbar card class="blue dark-3">
							<span class="title white--text">Personal Information</span>
						</v-toolbar>
						<v-card-text><span class="font-weight-bold">Employee ID:</span> {{ employeeData.employee_id }}</v-card-text>
						<v-card-text><span class="font-weight-bold">Employee Name:</span> {{ employeeData.fullname }}</v-card-text>
						<v-card-text><span class="font-weight-bold">Department:</span> {{employeeData.department}}</v-card-text>
						<v-card-text><span class="font-weight-bold">Email Address:</span> {{employeeData.email}}</v-card-text>
						<v-card-text><span class="font-weight-bold">Contact Number:</span> {{employeeData.contactNumber}}</v-card-text>

					</v-card>
				</v-flex>
			</v-layout>
		</v-flex>

		<update-user-password-modal></update-user-password-modal>
		<update-user-email-modal></update-user-email-modal>
		<update-user-contact-number></update-user-contact-number>
	</v-layout>
</template>

<script>
	import VueCookies from 'vue-cookies';
	import axios from 'axios';
	import updateUserPasswordModal from './updateUserPasswordModal.vue';
	import updateUserEmailModal from './updateUserEmailModal.vue';
	import updateUserContactNumberModal from './updateUserContactNumberModal.vue';

	export default {
		components : {
			'update-user-password-modal' : updateUserPasswordModal,
			'update-user-email-modal' : updateUserEmailModal,
			'update-user-contact-number' : updateUserContactNumberModal
		},

		created : function(){
			this.token = (VueCookies.get(this.cookieKey)).token;
			let _this = this;
			_this.token = (VueCookies.get(_this.cookieKey)).token;
			_this.id = (VueCookies.get(_this.cookieKey)).data.user.id;
			_this.eventHub.$emit("openGlobalLoaderModal");
			_this.getUsers()
			.then(function(res){
				console.log(res);
				_this.employeeData.fullname = res.data.data.fullname;
				_this.employeeData.employee_id = res.data.data.employee_id;
				_this.employeeData.department = res.data.data.department;
				_this.employeeData.contactNumber = res.data.data.contact_number;
				_this.employeeData.email = res.data.data.email;
				_this.employeeData.id = res.data.data.id;
				_this.eventHub.$emit("closeGlobalLoaderModal");
			});

			_this.eventHub.$on("userProfileNewEmail", function(email){
				_this.employeeData.email = email;

			});

			_this.eventHub.$on("userProfileNewContactNumber", function(contact_number){
				_this.employeeData.contactNumber = contact_number;
			})
		},

		mounted : function(){

		},

		data : function(){
			return{
				token : '',
				id : 0,
				employeeData : {
					fullname: '',
					employee_id : '',
					department : '',
					contactNumber : '',
					email : ''
				}
			}	
		},

		methods : {
			clickUpdatePW : function(){
				this.eventHub.$emit("openUpdateUserPasswordModal", this.id);
			},
			clickUpdateEmail : function(){
				this.eventHub.$emit("openUpdateUserEmailModal", this.id);
			},
			clickUpdateContactNumber : function(){
				this.eventHub.$emit("openUpdateUserContactNumberModal", this.id);
			},


			getUsers : function(){
				let _this = this;
				return axios.create({
					baseURL : _this.apiUrl,
					headers : {
						'Authorization' : `Bearer ${_this.token}`
					}
				})
				.get('/users/profile', {
					'params' : {
						'id' : _this.id
					}
				});
			}
		}
	};
</script>

<style scoped>

</style>